module.exports = __webpack_public_path__ + "static/solution-4a2bfe01bd277de6df11feabd6091156.mp4";